import ApolloClient from 'apollo-boost';

export const client = new ApolloClient({
    uri: process.env.REACT_APP_GRAPHLQL_ENDPOINT,
});

export function clientWithToken(token) {

    const headers = process.env.REACT_APP_X_MS_CLIENT_PRINCIPAL_ID ? { "Authorization": `Bearer ${token}`, "x-ms-client-principal-id": process.env.REACT_APP_X_MS_CLIENT_PRINCIPAL_ID } : { "Authorization": `Bearer ${token}` };
    return new ApolloClient({
        uri: process.env.REACT_APP_GRAPHLQL_ENDPOINT,
        headers: headers
    });
}